module.exports = __webpack_public_path__ + "assets/img/ma-logo-ad11e450.png";